import { DispatchDymoXML } from "../../../helpers/DispatchDymoXML";
import { JobLabelXml } from "../../../helpers/JobLabelXml";
import { PickingDymoXML } from "../../../helpers/PickingDymoXML";
import { SheetMetalDymoXml } from "../../../helpers/SheetMetalDymoXML";
import { momentDDMMYY } from "../../../helpers/utils";
import { WeldingDymoXML } from "../../../helpers/WeldingDymoXML";
import {
  ProductFinishEnum,
  ProductFinishLabels,
} from "../Products/productsTypes";

const getWeekNumber = (date: any) => {
  const d: any = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
  const dayNum: any = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart: any = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNum: any = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNum;
};

export const CommonJobLabelInjectDataXML = async (
  labelDataItems: any,
  dymo: any,
) => {
  const injectDataToXml = (xml: string, data: any) => {
    function wrapDispatch(text: any, maxLenPara?: any) {
      const maxLen = maxLenPara ? maxLenPara : 35;
      let words = text.split(" ");
      let line = "";
      let result = [];

      for (let w of words) {
        if ((line + w).length > maxLen) {
          result?.push(line);
          line = "";
        }
        line += w + " ";
      }
      if (line.trim()) {
        result?.push(line);
      }
      return result;
    }
    function getVariabntNameFontSize(value: any) {
      const len = value.length;

      if (len <= 40) return 16;
      if (len <= 50) return 14;
      return 11;
    }
    function getJobnumberSpace(str: string) {
      const maxLength = 18;
      const strLength = str?.length || 0;

      const spaceCount = Math.max(0, maxLength - strLength);

      return str + " ".repeat(spaceCount);
    }
    console.log(data, "labelDataItems?.variant_name");
    const newVariantName = wrapDispatch(`${data?.variant_name}`);
    const customerName = wrapDispatch(`${data?.customer_name}`, 20);
    const replacements = {
      "{{JOB_NUMBER}}": escapeXml(data?.order_number),
      "QUANTITY - {{QUANTITY}}": `QUANTITY - ${data.qty || 0}`,
      "{{DEPARTMENT}}": `${data?.department_name}` || "",
      "{{CUSTOMER_LINE_1}}": escapeXml(customerName?.[0]),
      "{{CUSTOMER_LINE_2}}": escapeXml(customerName?.[1]),
      "{{PRODUCT_NAME_LINE_1}}": escapeXml(newVariantName?.[0]),
      "{{PRODUCT_NAME_LINE_2}}": escapeXml(newVariantName?.[1]),
      "{{PRODUCT_NAME_LINE_3}}": escapeXml(newVariantName?.[2]),
      "{{PRODUCT_NAME_LINE_4}}": escapeXml(newVariantName?.[3]),
      "{{PRODUCT_NAME_LINE_5}}": escapeXml(newVariantName?.[4]),
      "{{PRODUCT_NAME_LINE_6}}": escapeXml(newVariantName?.[5]),
      "{{PRODUCT_NAME_LINE_7}}": escapeXml(newVariantName?.[6]),
      "13.01": data?.weekNumber || "",
      "13.10": data?.weekNumber || "",
    };

    let finalXml = xml;
    Object.entries(replacements).forEach(([key, value]) => {
      finalXml = finalXml.replace(key, value);
    });

    return finalXml;
  };

  const renderPromises = labelDataItems?.map(async (data: any, index: any) => {
    try {
      const xmlData = JobLabelXml;
      const dynamicXml = injectDataToXml(xmlData, data);
      const result = await dymo.renderLabel(dynamicXml);

      let base64: any = typeof result === "object" ? result.data : result;

      if (base64) {
        base64 = base64.replace(/"/g, "");
        const baseData = base64.startsWith("data:image")
          ? base64
          : `data:image/png;base64,${base64}`;

        return {
          XML: dynamicXml,
          preview: baseData,
          label_data: data,
          selected: true,
          id: index + 1,
          data: {
            qty: data?.qty,
          },
        };
      }
    } catch (error) {
      console.log("Label render failed for", data, error);
    }
    return null;
  });
  const results = await Promise.all(renderPromises);

  return results;
};

function escapeXml(value: any) {
  if (!value) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&apos;");
}

export const DispatchLabelInjectDataXML = async (
  labelDataItems: any,
  dymo: any,
) => {
  const injectDataToXml = (xml: string, data: any) => {
    function wrapDispatch(text: any) {
      const maxLen = 47;
      let words = text.split(" ");
      let line = "";
      let result = [];

      for (let w of words) {
        if ((line + w).length > maxLen) {
          result?.push(line);
          line = "";
        }
        line += w + " ";
      }
      if (line.trim()) {
        result?.push(line);
      }
      return result;
    }
    const newVariantName = wrapDispatch(`${data?.variant_name}`);

    const replacements = {
      "{{JOB_NUMBER}}": escapeXml(data?.order_number),
      "{{CUSTOMER_NAME}}": escapeXml(data?.customer_name),
      "PRODUCT - {{PRODUCT_NAME_LINE_1}}": `PRODUCT - ${escapeXml(
        newVariantName?.[0] || "",
      )}`,
      "PRODUCT - {{PRODUCT_NAME_LINE_2}}": `                       ${escapeXml(
        newVariantName?.[1] || "",
      )}`,
      "PRODUCT - {{PRODUCT_NAME_LINE_3}}": `                       ${escapeXml(
        newVariantName?.[2] || "",
      )}`,
      "{{DATE}}": escapeXml(
        data?.printed_data?.extra_data?.date
          ? momentDDMMYY(data?.printed_data?.extra_data?.date)
          : momentDDMMYY(new Date()),
      ),
      "{{DEPARTMENT}}": escapeXml(data?.department_name || ""),
      "{{PACKED_BY}}": data?.printed_data?.extra_data?.dispatch_user?.name
        ? escapeXml(data?.printed_data?.extra_data?.dispatch_user?.name)
        : "{{PACKED_BY}}",
      "{{FILL_DELIVERY}}":
        data?.printed_data?.extra_data?.collection_status == "delivery"
          ? `<Color A="1"          R="0" G="0" B="0"></Color>`
          : `<Color A="0"          R="0" G="0" B="0"></Color>`,
      "{{FILL_COLLECTION}}":
        data?.printed_data?.extra_data?.collection_status == "collection"
          ? `<Color A="1"     R="0" G="0" B="0"></Color>`
          : `<Color A="0"     R="0" G="0" B="0"></Color>`,
      "13.01": data?.weekNumber,
    };

    let finalXml = xml;
    Object.entries(replacements).forEach(([key, value]) => {
      finalXml = finalXml.replace(key, value);
    });

    return finalXml;
  };

  const renderPromises = labelDataItems.map(async (data: any, index: any) => {
    try {
      const xmlData = DispatchDymoXML;
      const dynamicXml = injectDataToXml(xmlData, data);
      const result = await dymo.renderLabel(dynamicXml);

      let base64: any = typeof result === "object" ? result.data : result;

      if (base64) {
        base64 = base64.replace(/"/g, "");
        const baseData = base64.startsWith("data:image")
          ? base64
          : `data:image/png;base64,${base64}`;

        return {
          XML: dynamicXml,
          label_data: {
            ...data,
            department_id: "dispatch",
            department_name: "dispatch",
          },
          preview: baseData,
          selected: true,
          id: index + 1,
        };
      }
    } catch (error) {
      console.log("Label render failed for", data, error);
    }
    return null;
  });
  const results = await Promise.all(renderPromises);

  return results;
};

export const PickingPackingLabelInjectDataXML = async (
  labelDataItems: any,
  dymo: any,
) => {
  const injectDataToXml = (xml: string, data: any) => {
    function wrapDispatch(text: any) {
      const maxLen = 70;
      let words = text.split(" ");
      let line = "";
      let result = "";

      for (let w of words) {
        if ((line + w).length > maxLen) {
          result += line + "\n";
          line = "";
        }
        line += w + " ";
      }
      return result + line;
    }

    const newVariantName = wrapDispatch(`${data?.variant_name}`);
    const replacements = {
      "{{JOB_NUMBER}}": escapeXml(data?.order_number),
      "{{CUSTOMER_NAME}}": escapeXml(`${data?.customer_name}`),
      "{{PRODUCT_NAME}}": escapeXml(newVariantName || ""),
      "13.01": data?.weekNumber || "",
      "{{DATE}}": data?.printed_data?.extra_data?.date
        ? momentDDMMYY(data?.printed_data?.extra_data?.date)
        : momentDDMMYY(new Date()) || "",
      "{{PACKED_BY}}": data?.printed_data?.extra_data?.dispatch_user?.name
        ? data?.printed_data?.extra_data?.dispatch_user?.name
        : "{{PACKED_BY}}",
      "{{FILL_DELIVERY}}":
        data?.printed_data?.extra_data?.collection_status == "delivery"
          ? `<Color A="1"          R="0" G="0" B="0"></Color>`
          : `<Color A="0"          R="0" G="0" B="0"></Color>`,
      "{{FILL_COLLECTION}}":
        data?.printed_data?.extra_data?.collection_status == "collection"
          ? `<Color A="1"     R="0" G="0" B="0"></Color>`
          : `<Color A="0"     R="0" G="0" B="0"></Color>`,
    };
    let finalXml = xml;
    Object.entries(replacements).forEach(([key, value]) => {
      finalXml = finalXml.replace(key, value);
    });

    return finalXml;
  };

  const renderPromises = labelDataItems?.map(async (data: any, index: any) => {
    try {
      const xmlData = PickingDymoXML;
      const dynamicXml = injectDataToXml(xmlData, data);
      const result = await dymo.renderLabel(dynamicXml);

      let base64: any = typeof result === "object" ? result.data : result;

      if (base64) {
        base64 = base64.replace(/"/g, "");
        const baseData = base64.startsWith("data:image")
          ? base64
          : `data:image/png;base64,${base64}`;

        return {
          XML: dynamicXml,
          preview: baseData,
          label_data: {
            ...data,
            department_id: "packing",
            department_name: "picking-packing",
          },
          selected: true,
          id: index + 1,
        };
      }
    } catch (error) {
      console.log("Label render failed for", data, error);
    }
    return null;
  });
  const results = await Promise.all(renderPromises);

  return results;
};

export const SheetMetalLabelInjectDataXML = async (
  labelDataItems: any,
  dymo: any,
) => {
  const injectDataToXml = (xml: string, data: any) => {
    function wrapDispatch(text: any, newMaxLength?: any) {
      const maxLen = newMaxLength ? newMaxLength : 60;
      let words = text.split(" ");
      let line = "";
      let result = [];

      for (let w of words) {
        if ((line + w).length > maxLen) {
          result?.push(line);
          line = "";
        }
        line += w + " ";
      }
      if (line.trim()) {
        result?.push(line);
      }
      return result;
    }
    const newVariantName = wrapDispatch(
      `${data?.variant_name}`,
      data?.variant_name?.length > 140
        ? 90
        : data?.variant_name?.length > 120
        ? 80
        : 70,
    );
    const PaintText = data?.paint ? "YES" : "NO";

    const isBatchQuantity = data?.printed_data?.extra_data?.batch_qauntity
      ? data?.printed_data?.extra_data?.batch_qauntity
      : null;
    const replacements = {
      "{{JOB_NUMBER}}": escapeXml(data?.order_number),
      "{{CUSTOMER_NAME}}": escapeXml(`${data?.customer_name}`),
      "{{DEPARTMENT}}": escapeXml(`${data?.department_name}`),
      "PRODUCT - {{PRODUCT_NAME_LINE_1}}": `PRODUCT - ${escapeXml(
        newVariantName?.[0] || "",
      )}`,
      "PRODUCT - {{PRODUCT_NAME_LINE_2}}": `                       ${escapeXml(
        newVariantName?.[1] || "",
      )}`,
      "TOTAL QUANTITY - {{QUANTITY}}": data?.printed_data?.extra_data?.quantity
        ? `TOTAL QUANTITY - ${data?.printed_data?.extra_data?.quantity}`
        : `TOTAL QUANTITY - ${data?.qty || 0}`,
      "BATCH QUANTITY - {{B_QUANTITY}}": isBatchQuantity
        ? `BATCH QUANTITY - ${isBatchQuantity}`
        : "BATCH QUANTITY - 1",
      "10.3": data?.weekNumber || "",
      "{{DATE}}": data?.printed_data?.extra_data?.date
        ? momentDDMMYY(data?.printed_data?.extra_data?.date)
        : momentDDMMYY(new Date()) || "",
      "{{PACKED_BY}}": data?.printed_data?.extra_data?.dispatch_user?.name
        ? escapeXml(data?.printed_data?.extra_data?.dispatch_user?.name)
        : "{{PACKED_BY}}",
      "{{PAINT_VALUE}}": PaintText,
    };
    let finalXml = xml;
    Object.entries(replacements).forEach(([key, value]) => {
      finalXml = finalXml.replace(key, value);
    });
    return finalXml;
  };

  const renderPromises = labelDataItems?.map(async (data: any, index: any) => {
    try {
      const xmlData = SheetMetalDymoXml;
      const dynamicXml = injectDataToXml(xmlData, data);
      const result = await dymo.renderLabel(dynamicXml);

      let base64: any = typeof result === "object" ? result.data : result;

      if (base64) {
        base64 = base64.replace(/"/g, "");
        const baseData = base64.startsWith("data:image")
          ? base64
          : `data:image/png;base64,${base64}`;

        return {
          XML: dynamicXml,
          preview: baseData,
          selected: true,
          label_data: data,
          id: index + 1,
          copies: data?.printed_data?.extra_data?.number_of_batches || 1,
        };
      }
    } catch (error) {
      console.log("Label render failed for", data, error);
    }
    return null;
  });
  const results = await Promise.all(renderPromises);

  return results;
};

export const WeldingLabelInjectDataXML = async (
  labelDataItems: any,
  dymo: any,
) => {
  const injectDataToXml = (xml: string, data: any) => {
    function wrapColor(text: any) {
      const maxLen = 42;
      let words = text.split(" ");
      let line = "";
      let result = [];

      for (let w of words) {
        if ((line + w).length > maxLen) {
          result?.push(line);
          line = "";
        }
        line += w + " ";
      }
      if (line.trim()) {
        result?.push(line);
      }
      return result;
    }

    const newColorName = wrapColor(`${data?.color || ""}`);

    function wrapBeamNAme(text: any) {
      let words = text.split(" ");
      const maxLen = 70;
      let line = "";
      let result = [];

      for (let w of words) {
        if ((line + w).length > maxLen) {
          result?.push(line);
          line = "";
        }
        line += w + " ";
      }
      if (line.trim()) {
        result?.push(line);
      }
      return result;
    }

    const newVariantName = wrapBeamNAme(`${data?.variant_name}`);
    const replacements = {
      "JOB - {{JOB_NUMBER}}": `JOB -  ${data?.order_number}`,
      "{{CUSTOMER_NAME}}": escapeXml(data?.customer_name),
      "{{DEPARTMENT}}": escapeXml(data?.department_name),
      "QUANTITY - {{QUANTITY}}": data?.printed_data?.extra_data?.quantity
        ? `QUANTITY - ${data?.printed_data?.extra_data?.quantity}`
        : `QUANTITY - ${data?.qty || 0}`,
      "{{DROP_VALUE}}": data?.drop || "",
      "{{BEAM_VALUE_1}}": escapeXml(newVariantName?.[0] || ""),
      "BEAM - {{BEAM_VALUE_2}}": `               ${escapeXml(
        newVariantName?.[1] || "",
      )}`,
      "RAL - {{COLOR_1}}": `RAL - ${newColorName[0] || ""}`,
      "RAL - {{COLOR_2}}": `           ${newColorName[1] || ""}`,
      "RAL - {{COLOR_3}}": `           ${newColorName[2] || ""}`,
      "RAL - {{COLOR_4}}": `           ${newColorName[3] || ""}`,
      "13.1": data?.weekNumber,
    };

    let finalXml = xml;
    Object.entries(replacements).forEach(([key, value]) => {
      finalXml = finalXml.replace(key, value);
    });
    return finalXml;
  };

  const renderPromises = labelDataItems?.map(async (data: any, index: any) => {
    console.log(data, "datadatadatadatadatadatadatadatadata");
    try {
      const xmlData = WeldingDymoXML;
      const dynamicXml = injectDataToXml(xmlData, data);
      const result = await dymo.renderLabel(dynamicXml);

      let base64: any = typeof result === "object" ? result.data : result;

      if (base64) {
        base64 = base64.replace(/"/g, "");
        const baseData = base64.startsWith("data:image")
          ? base64
          : `data:image/png;base64,${base64}`;

        return {
          XML: dynamicXml,
          preview: baseData,
          label_data: data,
          selected: true,
          id: index + 1,
          data: {
            qty: data?.qty,
          },
        };
      }
    } catch (error) {
      console.log("Label render failed for", data, error);
    }
    return null;
  });
  const results = await Promise.all(renderPromises);

  return results;
};

export const createLabelDataItemsData = async (
  productionJobsData: any,
  orderDetails: any,
  activeKey: any,
) => {
  const departmentsMap = new Map();
  const groupedDepartments: any[] = [];

  productionJobsData?.forEach((job: any) => {
    const deptId = job.department_id?._id?.toString() || "unknown";
    if (!departmentsMap?.has(deptId)) {
      const deptInfo = {
        department: job.department_id || { name: "Unknown Department" },
        jobs: [],
        weekNumber: null as number | null,
      };
      departmentsMap?.set(deptId, deptInfo);
      groupedDepartments?.push(deptInfo);
    }
    departmentsMap?.get(deptId)?.jobs?.push(job);
  });

  groupedDepartments?.sort((a: any, b: any) => {
    const posA = a.department?.position ?? Infinity;
    const posB = b.department?.position ?? Infinity;
    if (posA !== posB) return posA - posB;
    return (a.department?.name || "").localeCompare(b.department?.name || "");
  });
  const labelDataItems: any[] = [];

  groupedDepartments?.forEach((dept: any) => {
    dept.jobs.sort(
      (a: any, b: any) =>
        new Date(a.start_at).getTime() - new Date(b.start_at).getTime(),
    );

    if (dept.jobs.length > 0 && dept.jobs[0].start_at) {
      dept.weekNumber = getWeekNumber(new Date(dept?.jobs[0].start_at));
    }

    dept.jobs.forEach((job: any, index: number) => {
      const finishName =
        ProductFinishLabels[
          job?.product?.variants?.attributes?.finish as ProductFinishEnum
        ];
      labelDataItems.push({
        _id: job?._id,
        department_name: dept?.department?.name,
        department_id: dept?.department?._id,
        printed_data:
          job?.printed_data && job?.printed_data?.length > 0
            ? job?.printed_data?.find(
                (dep: any) => dep?.department_id == activeKey,
              )
            : [],
        weekNumber: job?.week_number
          ? job.week_number
          : `${dept?.weekNumber || ""}.${String(index + 1).padStart(2, "0")}`,
        drop:
          dept?.department?.slug == "welding"
            ? job?.product?.attributes?.drop == "standard"
              ? "Standard Drop (35mm)"
              : job?.product?.attributes?.drop == "custom"
              ? `${job?.product?.attributes?.custom_drop || ""} mm`
              : ""
            : "",
        customer_name: (orderDetails?.customer_snapshot?.company_name
          ? orderDetails?.customer_snapshot?.company_name
          : (orderDetails?.customer_snapshot?.first_name || "") +
            " " +
            (orderDetails?.customer_snapshot?.last_name || "")
        ).trim(),
        order_number: orderDetails?.order_id,
        variant_name: ["bom_part", "component"].includes(job?.item_type)
          ? job?.name
          : job?.product?.variants?.variant_name,
        color: job?.product?.attributes?.color || finishName || "",
        qty: job?.qty,
        slug: dept?.department?.slug || "",
      });
    });
  });

  return labelDataItems || [];
};
